import type { ReactNode } from 'react';

export const workflowFieldClass =
  'mt-1 block min-h-11 w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 text-base text-brand-midnight shadow-sm outline-none transition-colors placeholder:text-gray-400 focus:border-brand-cobalt focus:ring-2 focus:ring-brand-cobalt/20 dark:border-slate-600 dark:bg-slate-900 dark:text-white';

export const workflowSmallFieldClass =
  'mt-1 block min-h-10 w-full rounded-lg border border-gray-200 bg-white px-2.5 py-2 text-sm text-brand-midnight shadow-sm outline-none transition-colors focus:border-brand-cobalt focus:ring-2 focus:ring-brand-cobalt/20 dark:border-slate-600 dark:bg-slate-900 dark:text-white';

export const workflowSurfaceClass = 'surface-card rounded-2xl p-5 sm:p-7';

export const workflowActionsClass =
  'mt-6 flex gap-3 border-t border-gray-200 pt-4 dark:border-slate-700';

export const workflowPrimaryClass =
  'button-primary min-h-11 flex-1 justify-center';

export const workflowSecondaryClass =
  'button-secondary min-h-11 flex-1 justify-center';

export const WorkflowHeading = ({
  eyebrow,
  title,
  description,
}: {
  eyebrow?: string;
  title: string;
  description: string;
}) => (
  <div>
    {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
    <h1 className="mt-2 text-2xl font-bold tracking-[-0.04em] text-brand-midnight dark:text-white sm:text-3xl">
      {title}
    </h1>
    <p className="mt-2 max-w-2xl text-sm leading-6 text-brand-slate dark:text-slate-300">
      {description}
    </p>
  </div>
);

export const WorkflowError = ({ children }: { children: ReactNode }) => (
  <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700 dark:border-red-900 dark:bg-red-950/30 dark:text-red-300" role="alert">
    {children}
  </div>
);
